(()=>{
  if(window.gladifitLanguagePickerReady)return;window.gladifitLanguagePickerReady=true;
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-gladifit-language]');
    if(button){
      const picker=button.closest('details');const select=picker.parentElement.querySelector('select[name=language_code]');
      if(select && select.value!==button.dataset.gladifitLanguage){select.value=button.dataset.gladifitLanguage;select.dispatchEvent(new Event('change',{bubbles:true}));}
      picker.open=false;picker.querySelector('summary').focus();
    }
    document.querySelectorAll('.gladifit-language-picker[open]').forEach(picker=>{if(!picker.contains(event.target))picker.open=false});
  });
  document.addEventListener('keydown',event=>{
    const picker=event.target.closest('.gladifit-language-picker');if(!picker)return;
    if(event.key==='Escape'){picker.open=false;picker.querySelector('summary').focus();return;}
    if(!['ArrowDown','ArrowUp','Home','End'].includes(event.key))return;
    event.preventDefault();picker.open=true;const buttons=[...picker.querySelectorAll('button')];const index=buttons.indexOf(document.activeElement);
    const next=event.key==='Home'?0:event.key==='End'?buttons.length-1:event.key==='ArrowDown'?(index+1)%buttons.length:(index<0?buttons.length-1:(index-1+buttons.length)%buttons.length);
    buttons[next].focus();
  });
  document.addEventListener('focusout',event=>{const picker=event.target.closest('.gladifit-language-picker');if(picker)setTimeout(()=>{if(!picker.contains(document.activeElement))picker.open=false},0)});
})();
